import { Injectable } from '@angular/core';
import { Options } from 'nouislider';

@Injectable({ providedIn: 'root' })
// default config
export class NouiSliderConfig implements Options {
  range = { min: 0, max: 10 };
  start = 0;
  behaviour = 'snap';
  tooltips = true;
  connect = 'lower' as const;
}

// export the interface in case we needed it somewhere
export { Options as NouiSliderConfigInterface } from 'nouislider';
